/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placeholder_Api_UrlInputs */

const fr_placeholder_api_url = /** @type {(inputs: Placeholder_Api_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://api-next.eliophot.com`)
};

const en_placeholder_api_url = /** @type {(inputs: Placeholder_Api_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://api-next.eliophot.com`)
};

/**
* | output |
* | --- |
* | "https://api-next.eliophot.com" |
*
* @param {Placeholder_Api_UrlInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const placeholder_api_url = /** @type {((inputs?: Placeholder_Api_UrlInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeholder_Api_UrlInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_placeholder_api_url(inputs)
	return en_placeholder_api_url(inputs)
});